
























import { defineComponent } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import PlpProductBox from '~/components/solepro/PLPProductBox.vue';
import { ProductBox as ProductBoxType } from '~/utils/types/Product';
import { temiCaldiProductLink } from '~/helpers/trackings/24orepro/pages';
import CategoryBreadcrumbs from '~/modules/catalog/category/components/breadcrumbs/CategoryBreadcrumbs.vue';

export default defineComponent({
    props: {
        items: Array as PropType<ProductBoxType[]>,
        title: String
    },
    components: {
        PlpProductBox,
        CategoryBreadcrumbs
    },
    setup(props) {
        const trackTemiCaldiProductLink = (name) => temiCaldiProductLink(name, props.title);
        
        return {
            trackTemiCaldiProductLink
        }
    },
})
